/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-18 03:20 VN — WEB-20261018-suzitee-cart-preview-redesign
   Đã làm: popup "Preview" của dòng SP CÁ NHÂN HOÁ trong giỏ (drawer + trang /cart) làm lại theo ngôn ngữ popup add-on.
   Trước: drawer (#szmc-preview-modal, sz_minicart.js) và /cart (#eb-cus-preview-modal, cart-template.liquid) = tiêu đề "Preview" + ảnh + nút cam.
   Sau: ảnh preview lớn, tên SP + biến thể, 3 dòng trấn an (đúng policy shop),
   nhắc soát chính tả, CTA "Proceed to checkout" + "Back to cart".
   AI Agent làm theo chỉ thị của anh Hoá — 2026-10-18 03:40 VN — WEB-20261018-suzitee-cart-preview-redesign-v2
   Đã làm (v2): BỎ HẲN khối "Your personalization" (danh sách chữ/lựa chọn khách nhập + nút "Show all"): xoá persoRows(),
   đổi mảng property → chỉ nhận URL ảnh lớn "i" từ Liquid, xoá markup/handler "more". Ảnh to hơn, cột phải gom thành khối tin cậy.
   AI Agent làm theo chỉ thị của anh Hoá — 2026-10-18 04:00 VN — WEB-20261018-suzitee-preview-popup-pdp-v2
   Đã làm (v3): (1) BỎ HẲN zoom: xoá nút/hint/icon "Tap to zoom", handler click/mousemove/touchmove phóng to, nhánh Esc thu zoom —
   ảnh giờ là khung tĩnh .sz-cpv__frame. (2) THÊM chế độ PDP dùng CHUNG markup/CSS: khi popup preview Customily (ảnh tĩnh
   .cl-preview-image) mở trên trang SP, phủ popup này lên trên (Customily giữ nguyên bên dưới, chỉ mờ đi), nút chính
   "Add to cart" = bấm đúng nút #customily-cart-btn-preview của theme (→ #customily-cart-btn gốc của Customily, giữ đủ
   thuộc tính cá nhân hoá), "Keep editing"/×/Esc/nền = bấm nút đóng gốc của Customily. Không tự gọi /cart/add.
   Gọi từ observer SẴN CÓ trong snippets/customily-preview-sticky.liquid (window.__szCpvPdp) + dò ngắn khi bấm Preview/khi đang mở — không thêm observer.
   SP Customall / SP có điều khiển ảnh (upload) / file này không nạp / CSS chưa tới → popup preview cũ chạy như trước.
   Ảnh giỏ: GIỮ đúng thứ tự cũ _customily-preview > _customall_preview > ảnh dòng giỏ (hiện ảnh dòng ngay, bản lớn tải xong thì thay).
   Giỏ: chỉ bắt click ở pha capture cho dòng có <script.sz-cpv-data> (snippets/sz-cart-line.liquid); KHÔNG gỡ handler cũ.
   Dòng add-on (data-sz-addon / .sz-addon-pv) không đụng. */
(function () {
  'use strict';
  if (window.__szCpv) return; window.__szCpv = 1;
  var root = document.documentElement;
  var cur = null, lastFocus = null, locked = false;
  var CHECK = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M5 10.5l3.2 3.2L15 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var LOCK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="5" y="10.5" width="14" height="10" rx="2.2" fill="currentColor"/><path d="M8.2 10.5V8a3.8 3.8 0 017.6 0v2.5" fill="none" stroke="currentColor" stroke-width="2.2"/></svg>';
  var BAG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 8h12l-1 12.2a1 1 0 01-1 .8H8a1 1 0 01-1-.8z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M9 10V6.5a3 3 0 016 0V10" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* chuỗi từ Liquid `| json` có thể còn HTML entity (Man&#39;s) → giải mã */
  var deco = document.createElement('textarea');
  function un(s) { if (typeof s !== 'string' || s.indexOf('&') < 0) return s; deco.innerHTML = s; return deco.value; }
  function lineData(item) {
    var s = item && item.querySelector('script.sz-cpv-data');
    if (!s) return null;
    var d; try { d = JSON.parse(s.textContent || ''); } catch (e) { return null; }
    d.t = un(d.t || ''); d.v = un(d.v || ''); d.i = un(typeof d.i === 'string' ? d.i : '');
    return d;
  }

  /* drawer (giỏ) và khoá cuộn popup Customily (assets/sz-scrolllock.js, PDP) chặn touchmove/wheel ngoài vùng của chúng → bắt sớm nhất
     (window, capture) và chặn lan cho sự kiện TRONG popup này để thân popup cuộn được; nền tối thì không cho cuộn xuyên.
     Chỉ gắn khi popup đang mở (listener non-passive thường trực làm cuộn trang chậm). */
  var keep = function (e) { if (!cur || !cur.contains(e.target)) return; e.stopPropagation(); if (e.target === cur && e.cancelable) e.preventDefault(); };
  function keepOn(on) {
    var f = on ? 'addEventListener' : 'removeEventListener';
    window[f]('touchmove', keep, { capture: true, passive: false });
    window[f]('wheel', keep, { capture: true, passive: false });
  }
  function unlock() { keepOn(false); if (locked) { root.classList.remove('sz-cpv-lock'); locked = false; } }
  function hide() {
    if (!cur) return;
    var m = cur; cur = null; unlock();
    if (m.__busyT) clearInterval(m.__busyT);
    try { m.parentNode && m.parentNode.removeChild(m); } catch (e) {}
    /* PDP: giữ popup Customily mờ thêm chút cho nó kịp đóng (không nháy popup cũ); __szCpvPdp gỡ ngay khi nó biến mất */
    if (m.__pdp) setTimeout(function () { if (!(cur && cur.__pdp)) root.classList.remove('sz-ppv-up'); }, 700);
    try { if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }

  /* giỏ — giống popup add-on: bấm ĐÚNG nút checkout thật của giỏ (giữ hook sẵn có); không thấy thì /checkout */
  function checkout() {
    var d = root.classList.contains('szmc-open');
    var pick = function (sels) { for (var i = 0; i < sels.length; i++) { var n = document.querySelector(sels[i]); if (n) return n; } return null; };
    var real = d ? pick(['#szmcForm [name="checkout"]', '[form="szmcForm"][name="checkout"]', '#szMdockCheckout'])
                 : pick(['#cart_form #checkout', '#cart_form [name="checkout"]', '#checkout', '#szMdockCheckout']);
    hide();
    if (real) { real.click(); } else { location.href = '/checkout'; }
  }

  /* o: { t: tên SP, v: biến thể, q: SL, thumb: ảnh hiện ngay, big: ảnh lớn tải ngầm, pdp: true = trang SP } */
  function build(o) {
    var meta = [];
    if (o.v) meta.push('<span class="sz-cpv__chip">' + esc(o.v) + '</span>');
    if (o.q > 1) meta.push('<span class="sz-cpv__chip">Qty ' + esc(o.q) + '</span>');
    var m = document.createElement('div');
    m.className = 'sz-cpv' + (o.pdp ? ' sz-cpv--pdp' : '');
    m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true'); m.setAttribute('aria-labelledby', 'szCpvTitle');
    m.innerHTML =
      '<div class="sz-cpv__card" tabindex="-1">' +
        '<div class="sz-cpv__head">' +
          '<div class="sz-cpv__htxt"><h2 class="sz-cpv__title" id="szCpvTitle">Your design preview</h2>' +
          '<p class="sz-cpv__sub">' + (o.pdp ? 'Take a final look before adding to cart.' : 'Take a final look before checkout.') + '</p></div>' +
          '<button type="button" class="sz-cpv__x" aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="sz-cpv__scroll">' +
          '<div class="sz-cpv__media"><div class="sz-cpv__frame">' +
            '<img class="sz-cpv__img" alt="' + esc('Your personalized ' + (o.t || 'design')) + '" decoding="async" src="' + esc(o.thumb || o.big) + '">' +
          '</div></div>' +
          '<div class="sz-cpv__info">' +
            (o.t ? '<p class="sz-cpv__pname">' + esc(o.t) + '</p>' : '') +
            (meta.length ? '<div class="sz-cpv__meta">' + meta.join('') + '</div>' : '') +
            '<div class="sz-cpv__trust"><ul class="sz-cpv__checks">' +
              '<li>' + CHECK + '<span>Made to order — printed just for you</span></li>' +
              '<li>' + CHECK + '<span>Free replacement for damaged or incorrect items</span></li>' +
              '<li>' + CHECK + '<span>Tracking link emailed as soon as it ships</span></li>' +
            '</ul></div>' +
            /* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-19 16:55 VN — WEB-20261019-suzitee-cart-preview-p3
               Đã làm: dòng nhắc soát chính tả có thêm bản NGẮN (.sz-cpv__ns) cho popup giỏ mobile ≤749px; bản dài (.sz-cpv__nl) giữ nguyên
               chữ cũ cho desktop/tablet. Ẩn/hiện bằng assets/sz-cart-pv.css (mặc định .sz-cpv__ns ẩn → desktop không đổi). */
            '<p class="sz-cpv__note"><span class="sz-cpv__nl">Please double-check names, dates &amp; spelling in the preview — we print exactly what you entered.</span>' +
            '<span class="sz-cpv__ns">Check names &amp; spelling — we print exactly what you entered.</span></p>' +
          '</div>' +
        '</div>' +
        '<div class="sz-cpv__foot">' +
          '<button type="button" class="sz-cpv__go">' + (o.pdp ? BAG + '<span>Add to cart</span>' : LOCK + '<span>Proceed to checkout</span>') + '<i class="sz-cpv__spin" aria-hidden="true"></i></button>' +
          '<button type="button" class="sz-cpv__back">' + (o.pdp ? 'Keep editing' : 'Back to cart') + '</button>' +
        '</div>' +
      '</div>';
    /* bản lớn: tải ngầm, xong mới thay (không nháy trắng); hỏng thì giữ ảnh đang có */
    if (o.big && o.big !== o.thumb) {
      var img = m.querySelector('.sz-cpv__img'), pre = new Image();
      pre.decoding = 'async';
      pre.onload = function () { if (img) img.src = o.big; m.classList.add('is-hi'); };
      pre.src = o.big;
    } else { m.classList.add('is-hi'); }
    return m;
  }

  function wire(m, onGo, onClose) {
    var x = m.querySelector('.sz-cpv__x'), go = m.querySelector('.sz-cpv__go'), back = m.querySelector('.sz-cpv__back');
    /* đóng bằng 'click' (không touchend) → cú click đuôi không rơi xuống lớp mờ drawer */
    m.addEventListener('click', function (e) { if (e.target === m) onClose(); });
    x.addEventListener('click', function (e) { e.preventDefault(); onClose(); });
    back.addEventListener('click', function (e) { e.preventDefault(); onClose(); });
    go.addEventListener('click', function (e) { e.preventDefault(); onGo(); });
    var sc = m.querySelector('.sz-cpv__scroll');
    sc.addEventListener('scroll', function () { var on = sc.scrollTop > 4; if (on !== m.classList.contains('is-scrolled')) m.classList.toggle('is-scrolled', on); }, { passive: true });
    m.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = [].filter.call(m.querySelectorAll('button'), function (b) { return b.offsetParent !== null; });
      if (!f.length) return;
      var i = f.indexOf(document.activeElement);
      if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
    });
  }

  /* gắn vào trang; CSS (nạp không chặn render) chưa tới → trả false để popup cũ chạy, không hiện popup trần */
  function mount(m, focusBack) {
    hide();
    document.body.appendChild(m);
    if (getComputedStyle(m).position !== 'fixed') { try { document.body.removeChild(m); } catch (e) {} return false; }
    cur = m; lastFocus = focusBack; keepOn(true);
    if (!root.classList.contains('sz-cpv-lock')) { root.classList.add('sz-cpv-lock'); locked = true; }
    requestAnimationFrame(function () { m.classList.add('is-on'); });
    /* focus vào thẻ (không vào CTA → không hiện vòng focus khi mở bằng chạm); Tab đi tiếp các nút */
    try { m.querySelector('.sz-cpv__card').focus({ preventScroll: true }); } catch (e) {}
    return true;
  }

  function open(a) {
    var item = a.closest('.cart__item');
    var d = lineData(item); if (!d) return false;
    var th = item.querySelector('a.preview-image img') || item.querySelector('img');
    var thumb = th ? (th.currentSrc || th.src || '') : '';
    var m;
    try { m = build({ t: d.t, v: d.v, q: d.q, thumb: thumb, big: d.i || thumb }); } catch (e) { return false; }
    if (!mount(m, a)) return false;
    wire(m, checkout, hide);
    return true;
  }

  var SEL = 'a.customily-preview-cart, a.preview-image:not([data-sz-addon])';
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest(SEL);
    if (!a || !a.closest('.cart__item')) return;
    if (open(a)) { e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cur) {
      hide();
      e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }
  }, true);

  /* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-19 12:00 VN — WEB-20261019-suzitee-revert-pdp-preview-v2
     Đã làm: GỠ HẲN chế độ PDP (v3 18/10: window.__szCpvPdp phủ popup "Your design preview" lên popup Customily + bắt click nút Preview
     để giấu popup Customily ≤2.5s bằng html.sz-ppv-wait). Trang SP về popup preview Customily cũ như trước 18/10.
     Popup Preview của GIỎ (drawer + /cart) phía trên giữ nguyên. */
})();
